<template>
  <div class="jobs">
    <div class="tableConBox">
      <div class="tableTem">
        <div class="HSpace1"></div>
        <div class="searchBox flex flex-align-center">
          <div class="searchCon clearfix">
            <div class="left search flex flex-align-center">规则管理</div>
            <div class="right searchBtn">
              <button type="button" @click="clear">
                <i class="el-icon-plus"></i>添加规则
              </button>
            </div>
          </div>
        </div>
        <div class="HSpace2"></div>
        <div class="tableBox">
          <div class="tableBoxScroll">
            <table class="titleTable jobTitleTable">
              <tr>
                <th style="width: 10%" class="left1">序号</th>
                <th style="width: 30%" class="left1">计费名称</th>
                <!-- <th style="width: 10%" class="left1">封顶费用</th> -->
                <!-- <th style="width: 60%" class="left1">计费方式</th> -->
                <!-- <th style="width: 30%" class="left1">超出时段</th> -->
                <!-- <th style="width: 30%" class="left1">加收服务费</th> -->
                <th style="width: 10%">操作</th>
              </tr>
            </table>
            <div class="scrollBox">
              <div class="scroll">
                <table
                  class="conTable jobConTable"
                  :class="{ overLengthTable: rulesList.length > pageSize }"
                >
                  <tr v-for="(item, index) in rulesList" :key="index">
                    <td
                      style="width: 10%"
                      class="left1"
                    >{{ item.id ? index+1 : "" }}</td>
                    <td
                      style="width: 30%"
                      class="left1"
                      v-text="item.name"
                    ></td>
                    <!-- <td style="width: 10%" class="left1">
                      {{
                        item.id
                          ? item.upEnabled
                            ? item.upAmount
                            : "无封顶"
                          : ""
                      }}
                    </td> -->
                    <!-- <td
                      style="width: 10%"
                      class="left1"
                      v-text="
                        item.id
                          ? item.hourEnabled
                            ? '小时计费'
                            : '包段计费'
                          : ''
                      "
                    ></td> -->
                    <!-- <td style="width: 60%" class="left1">
                      {{
                        item.id
                          ? item.hourEnabled
                            ? item.sectionEnabled
                              ? `消费超出1小时,按超出分钟数区间计费。${item.sectionFrom}分钟之内免费;
                    超过${item.sectionFrom}分钟至${item.sectionTo}分钟,按${item.sectionTo}分钟计费,超过${item.sectionTo}分钟,按60分钟计算;`
                              : "消费超出1小时,按实际分钟数计费。"
                            : item.sectionEnabled
                            ? ` 消费超出${item.regionTime}小时，按每小时${item.oneHourAmount}元计费，超出的分钟数按区间计费。`
                            : `消费超出${item.regionTime}小时，按实际分钟数计费。`
                          : ""
                      }}
                    </td> -->
                    <!-- <td style="width: 30%" class="left1">
                      {{
                        item.id
                          ? item.serviceEnabled
                            ? `${item.serviceBegin}至${item.serviceEnd}加收服务费,
                      ${item.serviceFrom}分钟之内免费;超过${item.serviceFrom}分钟至${item.serviceTo}分钟,
                      按${item.serviceTo}分钟计费;超过${item.serviceTo}分钟,按60分钟计费;`
                            : `无`
                          : ""
                      }}
                    </td> -->
                    <td style="width: 10%">
                      <div v-if="item.id" class="btnInline">
                        <span title="修改" @click="getCurTable(item)"
                          ><i class="iconfont icon-bianji"></i
                        ></span>
                        <span title="删除" @click="delRules(item.id)"
                          ><i class="iconfont icon-icon1460188478041"></i
                        ></span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="pagination">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
            </el-pagination>
        </div> -->
      </div>
    </div>
    <el-dialog
      :title="curTableId ? '修改桌位' : '添加桌位'"
      :visible.sync="addTableVisible"
      size="tiny"
    >
      <div>
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="left itemName"><i>*</i>名称</span>
            <input
              type="text"
              style="width: 200px"
              class="left itemInput"
              v-model="newTable.numName"
              placeholder="请输入桌位名称"
            />
          </div>
          <div class="left msgItem clearfix">
            <span class="left itemName"><i>*</i>所属区域</span>
            <el-select v-model="newTable.parId" placeholder="请选择">
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.partitionName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="left msgItem clearfix">
            <span class="left itemName"><i>*</i>排序值</span>
            <input
              type="text"
              style="width: 100px"
              class="left itemInput"
              v-model="newTable.sort"
              placeholder="请输入排序值"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button type="button" @click="addTableVisible = false" class="cancel">
          取消
        </button>
        <button type="button" @click="addTable" class="save">保存</button>
      </span>
    </el-dialog>
    <!-- 添加修改计费规则 -->
    <div
      class="mask-wrap"
      v-if="showRuleInfo"
      @click.stop="showRuleInfo = false"
    >
      <div class="rules common-dialog" @click.stop="">
        <div class="tit">
          <span class="tit-cont">计费规则</span>
          <span class="close" @click="showRuleInfo = false">
            <i class="iconfont icon-guanbi1"></i>
          </span>
        </div>
        <div class="dialog-cont">
          <div class="set-item">
            <span class="item-left">
              计费方式：
            </span>
            <span class="item-right">
              <el-radio-group v-model="ruleInfo.countType">
                <el-radio :label="0">按时计费</el-radio>
                <el-radio :label="1">按次计费</el-radio>
              </el-radio-group>
            </span>
          </div>
          <br/>
          <div class="set-item">
            <span class="item-left">计费方式名称：</span>
            <span class="item-right">
              <input type="text" v-model="ruleInfo.ruleName" />
            </span>
          </div>
          <!--  -->
          
          <div class="set-item">
            <span class="item-left">
              {{ruleInfo.countType == 1 ? '每次' : '每小时'}}
            </span>
            <span class="item-right">
              <input
                type="text"
                style="width: 80px"
                v-model="ruleInfo.perHourMoney"
              />
              元
            </span>
          </div>
          <!--  -->
          <div class="set-item" v-if="false">
            <span class="item-left">
              <i
                :class="
                  ruleInfo.upTopFee
                    ? 'iconfont icon-Raidobox-xuanzhong'
                    : 'iconfont icon-Raidobox-weixuan'
                "
                @click="ruleInfo.upTopFee = !ruleInfo.upTopFee"
              ></i>
              费用封顶：
            </span>
            <span class="item-right">
              <input
                type="text"
                style="width: 80px"
                v-model="ruleInfo.upTopFeeMoney"
                :disabled="!ruleInfo.upTopFee"
              />
              元
            </span>
          </div>
          <div class="set-item other-style">
            <span class="item-left"> 开单后： </span>
            <span class="item-right">
              <select v-model="ruleInfo.openAfter.minute" style="width:150px;">
                <option value="0">0</option>
                <option
                  v-for="(item, index) in minutes"
                  :value="item"
                  :key="index"
                >
                  {{ item }}
                </option>
              </select>
              分钟之内，按
              <input
                type="text"
                v-model="ruleInfo.openAfter.money"
                style="width: 110px"
              />
              元计费;
            </span>
          </div>
          <div class="fee-style" v-if="false">
            <div class="panle-change">
              <span
                :class="nowFeeSty == 'hour' ? 'hour active' : 'hour'"
                @click="nowFeeSty = 'hour'"
                >按小时计费</span
              >
              <!-- <span :class="nowFeeSty=='timerange'?'time-range active':'time-range'"
              @click="nowFeeSty='timerange'"
              >按包段计费</span> -->
            </div>
            <div class="hour-set-cont panle-cont" v-if="nowFeeSty == 'hour'">
              <div class="per-hour">
                <span>
                  每小时
                  <input
                    type="text"
                    v-model="ruleInfo.perHourMoney"
                    style="width: 80px"
                  />
                  元
                </span>
              </div>
              <div class="cont-tit">
                <span>超出1小时的计费方式</span>
              </div>
              <div class="cont-item sty">
                <i
                  :class="
                    ruleInfo.actualEnabled
                      ? 'iconfont icon-Raidobox-xuanzhong'
                      : 'iconfont icon-Raidobox-weixuan'
                  "
                  @click="
                    ruleInfo.actualEnabled = true;
                    ruleInfo.sectionEnabled = false;
                  "
                ></i>
                消费超出1小时，按实际分钟数计费。
              </div>
              <div class="cont-item">
                <i
                  :class="
                    ruleInfo.sectionEnabled
                      ? 'iconfont icon-Raidobox-xuanzhong'
                      : 'iconfont icon-Raidobox-weixuan'
                  "
                  @click="
                    ruleInfo.sectionEnabled = true;
                    ruleInfo.actualEnabled = false;
                  "
                ></i>
                消费超出1小时，按超出分钟数区间计费。
              </div>
              <div class="item-set-cont" v-if="ruleInfo.sectionEnabled">
                <select
                  name=""
                  id=""
                  v-model="ruleInfo.sectionInfo.sectionFrom"
                >
                  <option value="0">0</option>
                  <option
                    v-for="(item, index) in minutes"
                    :value="item"
                    :key="index"
                  >
                    {{ item }}
                  </option>
                </select>
                分钟之内免费；超过{{ ruleInfo.sectionInfo.sectionFrom }}分钟至
                <select name="" id="" v-model="ruleInfo.sectionInfo.sectionTo">
                  <option value="0">0</option>
                  <option
                    v-for="(item, index) in minutes"
                    :value="item"
                    :key="index"
                  >
                    {{ item }}
                  </option>
                </select>
                分钟，按{{ ruleInfo.sectionInfo.sectionTo }} 分钟计费；超过{{
                  ruleInfo.sectionInfo.sectionTo
                }}分钟，按60分钟计费；
              </div>
              <!-- <div class="service">
                  <div class="cont-item sty">
                    <i 
                    :class="ruleInfo.serviceEnabled?'iconfont icon-Raidobox-xuanzhong':'iconfont icon-Raidobox-weixuan'"
                    @click="ruleInfo.serviceEnabled=!ruleInfo.serviceEnabled;"
                    ></i>
                    加收服务费<select name="" id="" v-model="ruleInfo.serviceInfo.serviceBegin">
                    <option value="0">0</option>
                  </select>至<select name="" id="" v-model="ruleInfo.serviceInfo.serviceTo">
                    <option value="0">0</option>
                  </select>
                  </div>
                  <div class="per-hour service-amount" v-if="ruleInfo.serviceEnabled" >
                    <span>
                      服务费:
                      <input type="text" v-model="ruleInfo.serviceInfo.serviceAmount" style="width:80px;"/> 元
                    </span>
                  </div>
                  <div class="item-set-cont" v-if="ruleInfo.serviceEnabled">
                    <select name="" id="" v-model="ruleInfo.serviceInfo.serviceFrom">
                      <option value="0">0</option>
                      <option  v-for="(item,index) in minutes" :value="item" :key="index">{{item}}</option>
                    </select>
                    分钟之内免费；超过{{ruleInfo.serviceInfo.serviceFrom}}分钟至
                    <select name="" id="" v-model="ruleInfo.serviceInfo.serviceTo">
                      <option value="0">0</option>
                      <option v-for="(item,index) in minutes" :value="item" :key="index">{{item}}</option>
                    </select>
                    分钟，按{{ruleInfo.serviceInfo.serviceTo}}
                    分钟计费；超过{{ruleInfo.serviceInfo.serviceTo}}分钟，按60分钟计费；
                  </div>
                </div> -->
            </div>
            <div
              class="timerange-set-cont panle-cont"
              v-if="nowFeeSty == 'timerange'"
            >
              <div class="per-hour">
                <span>
                  每<select name="" id="" v-model="ruleInfo.setHourRange">
                    <option value="0">0</option>
                    <option
                      :value="item"
                      v-for="(item, index) in hours"
                      :key="index"
                    >
                      {{ item }}
                    </option></select
                  >小时
                  <input
                    type="text"
                    style="width: 80px"
                    v-model="ruleInfo.perSetHourRangeMoney"
                  />
                  元
                </span>
              </div>
              <div class="cont-tit">
                <span>超出{{ ruleInfo.setHourRange }}小时的计费方式</span>
              </div>
              <div class="cont-item sty">
                <i
                  :class="
                    ruleInfo.actualEnabled
                      ? 'iconfont icon-Raidobox-xuanzhong'
                      : 'iconfont icon-Raidobox-weixuan'
                  "
                  @click="
                    ruleInfo.actualEnabled = true;
                    ruleInfo.sectionEnabled = false;
                  "
                ></i>
                消费超出{{ ruleInfo.setHourRange }}小时，按实际分钟数计费。
              </div>
              <div class="cont-item">
                <i
                  :class="
                    ruleInfo.sectionEnabled
                      ? 'iconfont icon-Raidobox-xuanzhong'
                      : 'iconfont icon-Raidobox-weixuan'
                  "
                  @click="
                    ruleInfo.sectionEnabled = true;
                    ruleInfo.actualEnabled = false;
                  "
                ></i>
                消费超出{{ ruleInfo.setHourRange }}小时，按每小时<input
                  type="text"
                  class="inp"
                  style="width: 80px"
                  v-model="ruleInfo.perHourMoney"
                />
                元计费，超出的分钟数按区间计费。
              </div>
              <div class="item-set-cont" v-if="ruleInfo.sectionEnabled">
                <select
                  name=""
                  id=""
                  v-model="ruleInfo.sectionInfo.sectionFrom"
                >
                  <option value="0">0</option>
                  <option
                    v-for="(item, index) in minutes"
                    :value="item"
                    :key="index"
                  >
                    {{ item }}
                  </option>
                </select>
                分钟之内免费；超过{{ ruleInfo.sectionInfo.sectionFrom }}分钟至
                <select name="" id="" v-model="ruleInfo.sectionInfo.sectionTo">
                  <option value="0">0</option>
                  <option
                    v-for="(item, index) in minutes"
                    :value="item"
                    :key="index"
                  >
                    {{ item }}
                  </option>
                </select>
                分钟，按{{ ruleInfo.sectionInfo.sectionTo }} 分钟计费；超过{{
                  ruleInfo.sectionInfo.sectionTo
                }}分钟，按60分钟计费；
              </div>
            </div>
            <div class="service" v-if="false">
              <div class="cont-item sty">
                <i
                  :class="
                    ruleInfo.serviceEnabled
                      ? 'iconfont icon-Raidobox-xuanzhong'
                      : 'iconfont icon-Raidobox-weixuan'
                  "
                  @click="ruleInfo.serviceEnabled = !ruleInfo.serviceEnabled"
                ></i>
                加收服务费<select
                  name=""
                  id=""
                  v-model="ruleInfo.serviceInfo.serviceBegin"
                >
                  <option value="00:00">0点</option>
                  <option
                    v-for="(item, index) in serviceHours"
                    :value="item < 10 ? `0${item}:00` : `${item}:00`"
                    :key="index"
                  >
                    {{ item }}点
                  </option></select
                >至<select
                  name=""
                  id=""
                  v-model="ruleInfo.serviceInfo.serviceEnd"
                >
                  <option value="00:00">0点</option>
                  <option
                    v-for="(item, index) in serviceHours"
                    :value="item < 10 ? `0${item}:00` : `${item}:00`"
                    :key="index"
                  >
                    {{ item }}点
                  </option>
                </select>
              </div>
              <div
                class="per-hour service-amount"
                v-if="ruleInfo.serviceEnabled"
              >
                <span>
                  服务费:
                  <input
                    type="text"
                    v-model="ruleInfo.serviceInfo.serviceAmount"
                    style="width: 80px"
                  />
                  元 / 每小时
                </span>
              </div>
              <div class="item-set-cont" v-if="ruleInfo.serviceEnabled">
                <select
                  name=""
                  id=""
                  v-model="ruleInfo.serviceInfo.serviceFrom"
                >
                  <option value="0">0</option>
                  <option
                    v-for="(item, index) in minutes"
                    :value="item"
                    :key="index"
                  >
                    {{ item }}
                  </option>
                </select>
                分钟之内免费；超过{{ ruleInfo.serviceInfo.serviceFrom }}分钟至
                <select name="" id="" v-model="ruleInfo.serviceInfo.serviceTo">
                  <option value="0">0</option>
                  <option
                    v-for="(item, index) in minutes"
                    :value="item"
                    :key="index"
                  >
                    {{ item }}
                  </option>
                </select>
                分钟，按{{ ruleInfo.serviceInfo.serviceTo }} 分钟计费；超过{{
                  ruleInfo.serviceInfo.serviceTo
                }}分钟，按60分钟计费；
              </div>
            </div>
          </div>
          <div class="confirm-box">
            <div class="btn-wrap">
              <span class="btn cancel" @click.stop="showRuleInfo = false"
                >取消</span
              >
              <span class="btn save" @click.stop="saveRules">保存</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { url } from "@/router/url.js";
export default {
  props: ["curStoreId", "pageSize"],
  data() {
    return {
      // ~~~
      changeItem: {}, //当前是否有选择修改某一项规则
      rulesList: [], //规则列表
      showRuleInfo: false,
      ruleInfo: {
        countType:0,
        id:0,
        enabled:true,
        ruleName: "",
        upTopFee: false, //是否封顶
        upTopFeeMoney: "", //封顶费用
        openAfter: {
          minute: 0,
          money: "",
        },
        billByHour: true,
        billByTimeRange: false,
        // 按小时
        perHourMoney: 0,
        actualEnabled: true, //超过小时数按实际分钟数来收费
        sectionEnabled: false, //超过小时数按分钟数区间来收费
        sectionInfo: {
          sectionFrom: 0, //多少分钟内免费
          sectionTo: 0, //超过此分钟按多少分钟计费
        },
        //
        // 包段
        setHourRange: 0, //包段时长
        perSetHourRangeMoney: 0, //包段金额
        // rangeInfo:{
        //    sectionFrom:0,//多少分钟内免费
        //    sectionTo:0,//超过此分钟按多少分钟计费
        // },
        //
        serviceEnabled: false, //是否加收服务费
        serviceInfo: {
          serviceAmount: 0, //服务费的金额
          serviceBegin: 0, //收取服务费开始时间
          serviceEnd: 0, //收取服务费结束时间
          serviceTo: 0, //服务费区段结束时间
          serviceFrom: 0, //好多分钟数内不收费
        },
      },
      nowFeeSty: "hour",
      minutes: 59,
      hours: 47,
      serviceHours: 23, //服务费加收时间段
      // ~~~
      totalElements: 0,
      currentPage: 1,
      area: "",
      areaList: [], //区域列表
      tableList: [], // 桌位列表
      // 新增桌位
      newTable: {
        parId: "",
        sort: "",
        numName: "",
      },
      curTableId: "", // 桌位id
      addTableVisible: false, // 控制新增弹框显示隐藏
      addJobApiBtn: true, // 控制新增桌位接口
      curTableItem: {}, //当前所选择的分区
      page: 0,
      size: 10,
    };
  },
  watch: {
    showRuleInfo(val) {
      if (!val) {
        this.changeItem = {};
        this.nowFeeSty = "hour";
      }
    },
  },
  methods: {
    // 添加计费规则
    saveRules() {
      console.log(this.ruleInfo);
      if (!this.checkRules()) {
        return;
      }
      let id;
      if (this.changeItem) {
        id = this.changeItem.id;
      } else {
        id = 0;
      }

      let data = {
        storeId: this.curStoreId,
        id:this.ruleInfo.id?this.ruleInfo.id:0,
        name: this.ruleInfo.ruleName,
        upAmount: this.ruleInfo.upTopFeeMoney,
        upEnabled: this.ruleInfo.upTopFee,
        beginOrderTime: this.ruleInfo.openAfter.minute,
        beginOrderAmount: this.ruleInfo.openAfter.money,
        hourEnabled: this.nowFeeSty == "hour" ? 1 : 0,
        regionEnabled: this.nowFeeSty != "hour" ? 1 : 0,
        oneHourAmount: this.ruleInfo.perHourMoney,
        actualEnabled: this.ruleInfo.actualEnabled ? 1 : 0,
        sectionEnabled: this.ruleInfo.sectionEnabled ? 1 : 0,
        sectionFrom: this.ruleInfo.sectionInfo.sectionFrom,
        sectionTo: this.ruleInfo.sectionInfo.sectionTo,
        serviceEnabled: this.ruleInfo.serviceEnabled ? 1 : 0,
        serviceBegin: this.ruleInfo.serviceInfo.serviceBegin,
        serviceEnd: this.ruleInfo.serviceInfo.serviceEnd,
        serviceFrom: this.ruleInfo.serviceInfo.serviceFrom,
        serviceTo: this.ruleInfo.serviceInfo.serviceTo,
        serviceAmount: this.ruleInfo.serviceInfo.serviceAmount,
        regionTime: this.ruleInfo.setHourRange,
        regionAmount: this.ruleInfo.perSetHourRangeMoney,
        countType: this.ruleInfo.countType,
        enabled:true,
      };

      this.$http({
        url: "rule-merge",
        method: "POST",
        data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.msg,
            customClass: "success",
          });
          this.showRuleInfo = false;
          this.getRules();
          return;
        }
      });
    },
    checkRules() {
      if (!this.ruleInfo.ruleName) {
        this.$message({
          message: "请填写规则名",
          customClass: "error",
        });
        return false;
      }
      // if(!this.ruleInfo.openAfter.money){
      //   this.$message({
      //     message: "请填写开单后金额",
      //     customClass: "error"
      //   });
      //   return false;
      // }
      if (
        !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
          this.ruleInfo.openAfter.money
        )
      ) {
        this.$message({
          message: "金额输入有误",
          customClass: "error",
          showClose: true,
          duration: 2000,
        });
        return false;
      }
      if (
        this.nowFeeSty == "hour" ||
        (this.nowFeeSty != "hour" && this.ruleInfo.sectionEnabled)
      ) {
        if (
          !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
            this.ruleInfo.perHourMoney
          )
        ) {
          this.$message({
            message: "金额输入有误",
            customClass: "error",
            showClose: true,
            duration: 2000,
          });
          return false;
        }
      }
      // if (this.nowFeeSty != "hour") {
      //   if (
      //     !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
      //       this.ruleInfo.perSetHourRangeMoney
      //     )
      //   ) {
      //     this.$message({
      //       message: "金额输入有误",
      //       customClass: "error",
      //       showClose: true,
      //       duration: 2000,
      //     });
      //     return false;
      //   }
      // }
      // if (this.ruleInfo.serviceEnabled) {
      //   if (
      //     !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
      //       this.ruleInfo.serviceInfo.serviceAmount
      //     )
      //   ) {
      //     this.$message({
      //       message: "金额输入有误",
      //       customClass: "error",
      //       showClose: true,
      //       duration: 2000,
      //     });
      //     return false;
      //   }
      // }
      if (this.ruleInfo.upTopFee && !this.ruleInfo.upTopFeeMoney) {
        this.$message({
          message: "请填写封顶金额",
          customClass: "error",
        });
        return false;
      }
      // if (this.ruleInfo.upTopFee) {
      //   if (
      //     !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
      //       this.ruleInfo.upTopFeeMoney
      //     )
      //   ) {
      //     this.$message({
      //       message: "金额输入有误",
      //       customClass: "error",
      //       showClose: true,
      //       duration: 2000,
      //     });
      //     return false;
      //   }
      // }
      return true;
    },
    //
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getTableList(val - 1);
    },
    changeReward(item) {
      console.log(item);
      this.$http({
        url: "employee-groups/update-empR",
        method: "GET",
        params: {
          groupId: item.id,
          reward: item.reward ? 0 : 1,
        },
      }).then((res) => {
        this.getareaList();
      });
    },
    //是否将此桌位的人员显示在语音呼叫客户端
    changeShowStatue(item) {
      this.$http({
        url: "update-show",
        method: "GET",
        params: {
          id: item.id,
          show: item.show ? 0 : 1,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            message: res.data.msg,
            customClass: "success",
          });
          this.getareaList();
        }
      });
    },
    getareaList: function () {
      this.$http.get("/par/all?storeId=" + this.curStoreId).then((res) => {
        let body = res.data;
        this.areaList = body;
      });
    },
    // 获取桌位列表
    getTableList: function (page = 0) {
      this.$http({
        url: "/num/all",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page,
          size: this.size,
        },
      }).then((res) => {
        let body = res.data.content;
        this.tableList = body;
        this.totalElements = res.data.totalElements;
        let num = this.pageSize - body.length;
        if (num > 0) {
          for (let i = 0; i < num; i++) {
            this.tableList.push({
              parName: "",
            });
          }
        }
      });
    },
    // 新增, 更新桌位
    addTable() {
      if (!this.newTable.numName) {
        this.$message({
          message: "请填写桌位号",
          customClass: "error",
        });
        return;
      }
      if (!this.newTable.parId) {
        this.$message({
          message: "请选择所属区域",
          customClass: "error",
        });
        return;
      }
      if (!/^(\d){1,3}$/.test(this.newTable.sort)) {
        this.$message({
          message: "排序值填写有误,排序范围在0-999",
          customClass: "error",
        });
        return;
      }
      if (this.newTable.sort > 1000 || this.newTable.sort < 0) {
        this.$message({
          message: "排序值填写有误,排序范围在0-999",
          customClass: "error",
        });
        return;
      }
      if (this.curTableId) {
        let data;
        if (this.curTableItem.numName == this.newTable.numName) {
          data = {
            parId: this.newTable.parId,
            sort: this.newTable.sort,
            numId: this.curTableItem.id,
          };
        } else {
          data = {
            parId: this.newTable.parId,
            numName: this.newTable.numName,
            sort: this.newTable.sort,
            numId: this.curTableItem.id,
          };
        }
        this.$http({
          url: "/num/update",
          method: "POST",
          data,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.msg,
              customClass: "success",
            });
            this.addTableVisible = false;
            this.newTable = { parId: "", sort: "", numName: "" };
            this.getTableList();
            this.curTableId = "";
          } else {
            this.$message({
              message: res.data.msg,
              customClass: "error",
            });
          }
        });
      } else {
        let parName = "";
        for (let i = 0; i < this.areaList.length; i++) {
          if (this.areaList[i].id == this.newTable.parId) {
            parName = this.areaList[i].partitionName;
          }
        }
        let data = {
          storeId: this.curStoreId,
          parId: this.newTable.parId,
          sort: this.newTable.sort,
          parName,
          numName: this.newTable.numName,
        };
        this.$http({
          url: "/num/add",
          method: "POST",
          data,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.msg,
              customClass: "success",
            });
            this.addTableVisible = false;
            this.newTable = { name: "", sort: "" };
            this.getTableList();
            this.curTableId = "";
          } else {
            this.$message({
              message: res.data.msg,
              customClass: "error",
            });
          }
        });
      }
    },
    // 删除桌位
    delRules: function (id) {
      this.$confirm("此操作将删除该计费规则, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post("rule-remove", { id }).then((res) => {
            this.getRules();
          });
        })
        .catch(() => {});
    },
    // 获得当前桌位信息
    getCurTable: function (item) {
      console.log(item);
      this.changeItem = item;
      this.nowFeeSty = item.hourEnabled ? "hour" : "timerange";
      this.ruleInfo = {
        id:item.id,
        countType:item.countType,
        ruleName: item.name,
        upTopFee: item.upEnabled, //是否封顶
        upTopFeeMoney: item.upAmount, //封顶费用
        openAfter: {
          minute: item.beginOrderTime,
          money: item.beginOrderAmount,
        },
        billByHour: true,
        billByTimeRange: false,
        // 按小时
        perHourMoney: item.oneHourAmount,
        actualEnabled: item.actualEnabled, //超过小时数按实际分钟数来收费
        sectionEnabled: item.sectionEnabled, //超过小时数按分钟数区间来收费
        sectionInfo: {
          sectionFrom: item.sectionFrom, //多少分钟内免费
          sectionTo: item.sectionTo, //超过此分钟按多少分钟计费
        },
        //
        // 包段
        setHourRange: item.regionTime, //包段时长
        perSetHourRangeMoney: item.regionAmount, //包段金额
        // rangeInfo:{
        //    sectionFrom:0,//多少分钟内免费
        //    sectionTo:0,//超过此分钟按多少分钟计费
        // },
        //
        serviceEnabled: item.serviceEnabled, //是否加收服务费
        serviceInfo: {
          serviceAmount: item.serviceAmount, //服务费的金额
          serviceBegin: item.serviceBegin, //收取服务费开始时间
          serviceEnd: item.serviceEnd, //收取服务费结束时间
          serviceTo: item.serviceTo, //服务费区段结束时间
          serviceFrom: item.serviceFrom, //好多分钟数内不收费
        },
      };
      this.showRuleInfo = true;
    },
    // 清除信息
    clear: function () {
      this.ruleInfo = {
        id:0,
        countType:0,
        enabled:true,
        ruleName: "",
        upTopFee: false, //是否封顶
        upTopFeeMoney: "", //封顶费用
        openAfter: {
          minute: 0,
          money: "",
        },
        billByHour: true,
        billByTimeRange: false,
        // 按小时
        perHourMoney: 0,
        actualEnabled: true, //超过小时数按实际分钟数来收费
        sectionEnabled: false, //超过小时数按分钟数区间来收费
        sectionInfo: {
          sectionFrom: 0, //多少分钟内免费
          sectionTo: 0, //超过此分钟按多少分钟计费
        },
        //
        // 包段
        setHourRange: 0, //包段时长
        perSetHourRangeMoney: 0, //包段金额
        // rangeInfo:{
        //    sectionFrom:0,//多少分钟内免费
        //    sectionTo:0,//超过此分钟按多少分钟计费
        // },
        //
        serviceEnabled: false, //是否加收服务费
        serviceInfo: {
          serviceAmount: 0, //服务费的金额
          serviceBegin: 0, //收取服务费开始时间
          serviceTo: 0, //收取服务费结束时间
          serviceFrom: 0, //好多分钟数内不收费
        },
      };
      this.showRuleInfo = true;
    },
    getRules() {
      this.$http({
        url: "rule-list",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        this.rulesList = res.data;
        let num = this.pageSize - res.data.length;
        if (num > 0) {
          for (let i = 0; i < num; i++) {
            this.rulesList.push({
              name: "",
            });
          }
        }
      });
    },
  },
  created: function () {},
  activated: function () {
    this.getRules();
  },
};
</script>
<style lang="scss">
@import "../../../../../static/css/common.scss";
@import "../../../tableTemplate/tableTem.scss";
@import "../../../tableTemplate/el-dialog.scss";
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// index.vue?5b5c949e